/* eslint-disable react/jsx-key */
"use client";
// import { LoadingCard, ProductCard, SideFilters } from "../../components";
import SideFilters from "../../components/SideFilters";
import Breadcrumbs from "../../components/Breadcrumb";
import PaginationBar from "../../components/PaginationBar";
import Image from "next/image";
import React, { useState, useEffect, useDeferredValue } from "react";
import { Badge, Button, Col, Form, Pagination, Row } from "react-bootstrap";
import {
  filterIcon,
  search,
  searchLight,
  sortIcon,
} from "../../../public/icons";
import { Swiper, SwiperSlide } from "swiper/react";
interface prop {
  setMobileFilter: (string: string | undefined) => String | undefined;
}

interface banners {
  plp_Carousal: string | string[];
}
import styles from "../../styles/ProductListing.module.css";
import NoItemsFound from "../../components/NoItemsFound";
import BadgePill from "./BadgePill";
import { useSearchParams } from "next/navigation";
import ProductCard from "../../components/ProductCard";
import LoadingCard from "../../components/LoadingCard";
import FilterPills from "../../components/FilterPills";
import NotFound from "../../app/not-found";
import AdBanners from "../Home/AdBanners";
import { useQuery } from "@tanstack/react-query";

import { getBannesByPage, getFeaturedListings } from "../../app/apis/getApis";
import {
  Autoplay,
  FreeMode,
  Mousewheel,
  Navigation,
  Virtual,
} from "swiper/modules";
const Listing = ({
  dependentFilters,
  isSandwichOpen,
  setisSandwichOpen,
  setCategory,
  setBrand,
  setColor,
  catId,
  setCondition,
  setLocation,
  setOrderBy,
  orderBy,
  getFilters,
  setdependentFilters,
  filters,
  totalItems,
  filtersData,
  setMobileFilter,
  shopItems,
  sizeOfPages,
  setSizeOfPages,
  currentPage,
  changePage,
  noOfPages,
  setCatCahnge,
  search,
  setSearch,
  priceRange,
  setPriceRange,
  removeDependentFiltersParam,
  setfiltersData,
  seeMoreFilters,
  clearDependentFilters,
  filterINDFilters,
  setCurrentPage,
  getItems,
}: any) => {
  const params = useSearchParams();
  const [banners, setBanners] = useState<banners>();
  const category_id =
    filterINDFilters?.filterIndDpendentFilters?.hasOwnProperty("category")
      ? filterINDFilters?.filterIndDpendentFilters?.category[0]?.id
      : "";
  const getFeatured = useQuery({
    queryKey: ["featuredListing", catId],
    queryFn: () => getFeaturedListings(catId, "plp-top"),
    refetchOnWindowFocus: false,
    cacheTime: 0,

    onSuccess: (data) => { },
  });



  const getBanners = useQuery({
    queryKey: ["banners"],
    queryFn: () => getBannesByPage("plp"),
    refetchOnWindowFocus: false,
    cacheTime: 0,
    onSuccess: (data) => {
      setBanners(data?.data?.body?.data);
    },
  });

  function toTitleCase(arg0: any): string {
    throw new Error("Function not implemented.");
  }

  function handleChangeDependentFilter(val: any, index: any): void {
    throw new Error("Function not implemented.");
  }

  function handleCheckboxChange(val: any, index: any): void {
    throw new Error("Function not implemented.");
  }

  return (
    <div className={`${styles.listingdiv}`}>
      <AdBanners
        Banners={banners?.plp_Carousal}
        isLoading={getBanners.isLoading}
      />
      <div className="main">
        <div className="d-flex justify-content-between mb-1">
          {" "}
          <Breadcrumbs />
        </div>

        {(Object?.values(filters?.filterIndDpendentFilters || {}).length > 0 || filters?.price) && (
          <FilterPills
            filters={filters}
            setPriceRange={setPriceRange}
            setfiltersData={setfiltersData}
            setdependentFilters={setdependentFilters}
            dependentFilters={dependentFilters}
            clearDependentFilters={clearDependentFilters}
            setCatCahnge={setCatCahnge}
            priceRange={priceRange}
            filtersData={filtersData}
          />
        )}

        <Row className="">
          <Col lg="3">
            <SideFilters
              dependentFilters={dependentFilters}
              setisSandwichOpen={setisSandwichOpen}
              isSandwichOpen={isSandwichOpen}
              setCategory={setCategory}
              setOrderBy={setOrderBy}
              orderBy={orderBy}
              isLoading={getFilters?.isLoading}
              setdependentFilters={setdependentFilters}
              setBrand={setBrand}
              setColor={setColor}
              setCondition={setCondition}
              setLocation={setLocation}
              filtersData={filtersData}
              setCatCahnge={setCatCahnge}
              setPriceRange={setPriceRange}
              setSearch={setSearch}
              search={search}
              priceRange={priceRange}
              removeDependentFiltersParam={removeDependentFiltersParam}
              setfiltersData={setfiltersData}
              seeMoreFilters={seeMoreFilters}
              clearDependentFilters={clearDependentFilters}
              changePage={changePage}
            />
          </Col>

          <Col lg="9">
            <h1 className={`${styles.h1}`}>Products</h1>
            <div className="w-100 border-lg-bottom borderBottom  pb-2 justify-content-between d-block d-lg-flex-end d-md-flex-end d-lg-flex-end">
              <div className="d-flex justify-content-between align-items-baseline">
                <p className={`w-100 ${styles.results}`}>
                  {shopItems?.length > 0 &&
                    `${(currentPage - 1) * sizeOfPages + 1}-${Math.min(currentPage * sizeOfPages, totalItems)} of ${totalItems} Results`}
                </p>
                <div className="d-flex w-100">
                  <Form.Select
                    onChange={(e) => {
                      e.preventDefault();
                      setSizeOfPages(parseInt(e.target.value, 10));
                    }}
                    className="ms-3"
                    aria-label="Default select example"
                  >
                    <option value={24}>Showing 1 - 24</option>
                    <option value={48}>Showing 1 - 48</option>
                    <option value={72}>Showing 1 - 72</option>
                  </Form.Select>
                  <Form.Select
                    className="d-none d-lg-block ms-3"
                    aria-label="Default select example"
                    disabled={search ? true : false}
                    value={orderBy?.price}
                    defaultValue=""
                    onChange={(e) => {
                      setCatCahnge(true);
                      let value = e.target.value;
                      if (value === "asc") {
                        setOrderBy({
                          price: "asc",
                        });
                      } else if (value === "desc") {
                        setOrderBy({ price: "desc" });
                      } else if (value === "D-asc") {
                        setOrderBy({ discount: "asc" });
                      } else if (value === "D-desc") {
                        setOrderBy({ discount: "desc" });
                      }
                    }}
                  >
                    <option key="blankChoice" hidden value="">
                      {" "}
                      Sort by{" "}
                    </option>
                    <option id="price" value="asc">
                      Price low to high
                    </option>
                    <option id="price" value="desc">
                      Price high to low
                    </option>
                    <option id="discount" value="D-asc">
                      Discount low to high
                    </option>
                    <option id="discount" value="D-desc">
                      Discount high to low
                    </option>
                  </Form.Select>
                </div>
              </div>
            </div>

            <div className="w-100 d-block  d-md-flex mt-3 d-lg-none ">
              <Button
                onClick={() => {
                  setisSandwichOpen(true);
                }}
                className={`w-100 me-3 mb-2 rounded-2 ${styles.filter_btn} `}
              >
                <Image alt="filterIcon" className="me-1" src={filterIcon} />{" "}
                Filter by
              </Button>
              <Button
                onClick={() => {
                  setCatCahnge(true);
                  setMobileFilter("sort");
                }}
                className={`w-100 rounded-2 mb-2  ${styles.filter_btn}`}
              >
                {" "}
                <Image alt="sortIcon" src={sortIcon} /> Sort by
              </Button>
            </div>

            <div
              className={` rounded-3 p-3 ${styles.swiper} ${getFeatured.isLoading ? "d-none" : ""}`}
              style={{ backgroundColor: " rgb(203, 195, 227)" }}
            >
              <Swiper
                slidesPerView={2}
                spaceBetween={10}
                cssMode={true}
                // sl={1}

                navigation={true}
                mousewheel={true}
                modules={[Virtual, Navigation, Mousewheel, Autoplay]}
                // autoplay={false}
                autoplay={{
                  delay: 3500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  540: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                }}
                className="mySwiper"
              >
                {getFeatured?.data?.data?.body?.data?.map(
                  (data: any, index: number) => (
                    // eslint-disable-next-line react/jsx-key
                    <SwiperSlide>
                      <ProductCard
                        // key={index}
                        listingId={data?.listing_id}
                        item={data?.item}
                        title={data?.listing_title}
                        condition={data?.item.condition_item}
                        isLoading={getFilters?.isLoading}
                        discount={parseInt(data.online_discount)}
                        discount_unit={data?.online_discount_unit}
                        price={data.online_price}
                        color={data?.listingColorAssociations}
                        listedQuantity={data.listed_quantity}
                        isRecommendationCards={false}
                        effectivePrice={data?.effective_price}
                        activationDate={data?.activation_date}
                        is_featured={data?.is_featured}
                        discount_percentage={data.discount_percentage}
                        paidSeller={data.item.shopTable.on_payment}
                        // quantity={data?.listed_quantity}
                        width={"full"}
                        featured={true}
                      />
                    </SwiperSlide>
                  )
                )}
              </Swiper>
            </div>

            <Row className="d-flex h-50 p-md-3 p-1">
              {getItems?.isLoading ? (
                [1, 2, 3, 4, 5, 6, 7.8].map((item) => (
                  <Col
                    className="mt-4 gx-3 gy-2  "
                    lg={2}
                    xl={3}
                    md={4}
                    sm={6}
                    xs={6}
                  >
                    <LoadingCard />
                  </Col>
                ))
              ) : (
                <>
                  {shopItems?.map((data: any, index: number) => (
                    // eslint-disable-next-line react/jsx-key
                    <ProductCard
                      // key={index}
                      listingId={data?.listing_id}
                      item={data?.item}
                      title={data?.listing_title}
                      condition={data?.item.condition_item}
                      isLoading={getFilters?.isLoading}
                      discount={parseInt(data.online_discount)}
                      discount_unit={data?.online_discount_unit}
                      price={data.online_price}
                      color={data?.listingColorAssociations}
                      listedQuantity={data.listed_quantity}
                      isRecommendationCards={false}
                      effectivePrice={data?.effective_price}
                      activationDate={data?.activation_date}
                      is_featured={data?.is_featured}
                      discount_percentage={data.discount_percentage}
                      paidSeller={data.item.shopTable.on_payment}

                    // quantity={data?.listed_quantity}
                    />
                  ))}
                </>
              )}

              {shopItems?.length > 0 && (
                <PaginationBar
                  noOfPages={noOfPages}
                  currentPage={currentPage}
                  changePage={changePage}
                />
              )}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Listing;
